class CacheMap {
  constructor(prefix = "cache") {
    this.prefix = prefix;
  }

  _buildKey(key) {
    return `${this.prefix}_${key}`;
  }

  get(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(this._buildKey(key)));
    } catch (error) {
      return false;
    }
  }

  set(key, value) {
    return window.sessionStorage.setItem(
      this._buildKey(key),
      JSON.stringify(value)
    );
  }

  has(key) {
    return window.sessionStorage.getItem(this._buildKey(key)) !== null;
  }

  peek(key) {
    return this.has(key) ? this.get(key) : false;
  }

  delete(key) {
    return window.sessionStorage.removeItem(this._buildKey(key));
  }

  clear() {
    window.sessionStorage.clear();
  }
}

export default CacheMap;
